




















import { Vue, Component, Watch } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';

import Builder from '@/utils/Builder';
import RiskResources from '@/services/RiskResources';

import { WPPost, WPCategory } from '@/common/RiskResources';

import OnDemandWebinarCard from './OnDemandWebinarCard.vue';

@Component({
	name: 'SuggestedOnDemandWebinars',
	components: {
		OnDemandWebinarCard,
	},
})
export default class SuggestedOnDemandWebinars extends Vue {
	@State('webinars', { namespace: 'RiskResources' }) private posts: WPPost[];
	@State('webinar_categories', { namespace: 'RiskResources' }) private categories: WPCategory[];
	private Builder: typeof Builder = Builder;
	private RiskResources: typeof RiskResources = RiskResources;
	private filter: string = 'all';

	/**
	 * Make sure that we show the correct claim reviews for the
	 * current brand.
	 */
	get showCorrectBrand() {
		return (this.posts.filter(post => RiskResources.brandHasAccess(post)) || []).slice(0, 4);
	}
}
